<template>
  <div>
    <el-dialog
        :visible.sync="isOpen"
        :show-close="true"
        :before-close="handleClose"
        class="advanced_filter"
        width="30%"
        title="Bộ lọc nâng cao"
    >

      <div class="body_dialog">
        <div class="wrap_option_filter">
          <div>
            <div
                class="element_filter"
                :style="[
                    {borderBottom: dataFilter.applyTime ? '1px solid #ccc' : ''}
                ]"
            >
              <span>Phiếu có áp dụng thời gian :</span>
              <div style="display: flex; gap: 0 20px">
                <span>
                  <el-radio v-model="dataFilter.applyTime" :label="true">Có</el-radio>
                  <el-radio v-model="dataFilter.applyTime" :label="false">Không</el-radio>
                </span>
                <span
                    v-if="dataFilter.applyTime !== null"
                    style="display: flex;
                  align-items: center;
                  justify-content: center;
                  border: 1px solid #ccc;
                  width: 16px;
                  height: 16px;
                  border-radius: 4px;
                  cursor: pointer"
                    @click="refreshFilterApplyTime"
                    class="el-icon-refresh-left"
                ></span>
              </div>
            </div>
            <div
                style="margin-top: 10px"
                v-if="dataFilter.applyTime"
            >
              <el-row type="flex">
                <el-col :span="24">
                  <div style="margin-bottom: 10px">
                    <span>
                      <span style="color: #F56C6C">*</span>
                      Chọn ngày áp dụng:
                    </span>
                  </div>
                </el-col>
              </el-row>
              <el-row type="flex" :gutter="10">
                <el-col :span="12">
                  <div style="margin-bottom: 6px">
                    Ngày bắt đầu:
                  </div>
                  <div>
                    <el-date-picker
                        style="width: 100%;"
                        v-model="dataFilter.firstDay"
                        type="date"
                        format="dd/MM/yyyy"
                        value-format="yyyy-MM-dd"
                        placeholder="Ngày bắt đầu"
                    >
                    </el-date-picker>
                    <span v-if="isValid.firstDay" style="color: #F56C6C; display: block; margin-top: 2px">*Vui lòng chọn trường này!</span>
                  </div>
                </el-col>

                <el-col :span="12">
                  <div style="margin-bottom: 6px">
                    Ngày kết thúc:
                  </div>
                  <div>
                    <el-date-picker
                        style="width: 100%;"
                        v-model="dataFilter.lastDay"
                        type="date"
                        format="dd/MM/yyyy"
                        value-format="yyyy-MM-dd"
                        placeholder="Ngày kết thúc"
                        :disabled="!dataFilter.firstDay"
                        :picker-options="pickerLastDayOptions"
                    >
                    </el-date-picker>
                    <span v-if="isValid.lastDay" style="color: #F56C6C; display: block; margin-top: 2px">*Vui lòng chọn trường này!</span>
                  </div>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer">
        <div>
          <el-button type="danger" @click="handleClose">
            <i class="el-icon-circle-close"/>
            Đóng
          </el-button>

          <el-button type="success" @click="handleSave">
            <i class="el-icon-circle-check"/>
            Xác nhận
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },

  data() {
    return {
      pickerLastDayOptions: {
        disabledDate: (time) => {
          const fistDay = new Date(this.dataFilter.firstDay);
          return time.getTime() < fistDay.getTime();
        },
      },

      dataFilter: {
        applyTime: null,
        firstDay: "",
        lastDay: ""
      },

      isValid: {
        firstDay: false,
        lastDay: false,
      }
    }
  },

  watch: {
    "dataFilter.applyTime"(newVal) {

      if (!newVal) {
        this.dataFilter.firstDay = "";
        this.dataFilter.lastDay = "";
        this.isValid.firstDay = false;
        this.isValid.lastDay = false;
      }
    },

    "dataFilter.firstDay"(newVal) {
      this.isValid.firstDay = !newVal && this.dataFilter.applyTime;

      if (!newVal) {
        this.dataFilter.lastDay = ""
      }
    },

    "dataFilter.lastDay"(newVal) {
      this.isValid.lastDay = !newVal && this.dataFilter.applyTime;
    },
  },

  created() {

  },

  methods: {
    handleClose() {
      this.$emit("closeDialog");
    },

    refreshFilterApplyTime() {
      this.dataFilter.applyTime = null;
    },

    getDataAdvancedFilter(data) {
      this.dataFilter = data;
    },

    handleSave() {
      if (this.validationSubmit()) {
        const data = this.dataFilter;
        this.$emit("saveDialog", data);
      }
    },

    validationSubmit() {
      const applyTime = this.dataFilter.applyTime;
      const firstDay = this.dataFilter.firstDay;
      const lastDay = this.dataFilter.lastDay;

      if (applyTime) {

        if (!firstDay || !lastDay) {
          this.isShowMessageRangeDate();
          return false;
        }
        return true;
      }

      return true;
    },

    isShowMessageRangeDate() {
      const firstDay = this.dataFilter.firstDay;
      const lastDay = this.dataFilter.lastDay;

      if (!firstDay) {
        this.isValid.firstDay = true;
      }

      if (!lastDay) {
        this.isValid.lastDay = true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.element_filter {
  display: flex;
  gap: 0 70px;
  padding-bottom: 12px;
}
</style>